import {
  FormField as BrFormField,
  Fieldset,
  ErrorMessage,
  IconName,
  InfoIcon,
} from "@vwfs-bronson/bronson-react";
import { useField } from "formik";

interface FormFieldProps {
  render: any;
  name: string;
  hint?: string;
  labelText?: string;
  infoIcon?: any;
  ariaLabelInfoIcon?: string;
  required?: boolean;
  type:
    | "input"
    | "autosuggest"
    | "textarea"
    | "select"
    | "checkbox"
    | "combobox"
    | "other"
    | "group"
    | undefined;
  className?: string;
}

export const FormField = ({
  render,
  name,
  hint,
  labelText,
  infoIcon,
  ariaLabelInfoIcon,
  required,
  type = "input",
  className,
}: FormFieldProps) => {
  const [field, meta] = useField(name);
  return (
    <Fieldset.Row>
      <BrFormField
        hint={hint}
        infoIcon={
          infoIcon ? (
            <InfoIcon
              icon={IconName.INFO}
              aria-label={ariaLabelInfoIcon || infoIcon}
            >
              {infoIcon}
            </InfoIcon>
          ) : null
        }
        labelForId={name}
        labelText={required ? labelText : `${labelText} (Facultatif)`}
        errorMessage={
          meta.error &&
          meta.touched && (
            <ErrorMessage
              id={name}
              dangerouslySetInnerHTML={{
                __html: meta.touched && meta.error,
              }}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            />
          )
        }
        required={required}
        type={type}
        className={className}
      >
        {render({
          id: name,
          required,
          error: meta.touched && meta.error ? "true" : undefined,
          ...(meta.touched && meta.error && { "aria-invalid": true }),
          ...(meta.touched &&
            meta.error && { "aria-describedby": `error-${name}` }),
          ...field,
        })}
      </BrFormField>
    </Fieldset.Row>
  );
};
